import React, { useState, useEffect } from 'react';
import ImageDisplay from './ImageDisplay';

import config from './../../config';

function ImageList(props) {
	const [selectedImage, setSelectedImage] = useState(null);

	useEffect(() => {
		setSelectedImage(props.data[0]);
	}, [props.data]);

	return (
		<div className={props.className || ''}>
			{
				props.data.length > 0 && selectedImage &&
				<ImageDisplay className="mb-2"
					src={config.mediaUrl+selectedImage.path}
					title={selectedImage.name}
					text={(selectedImage.text ? selectedImage.text : '')+(selectedImage.credit ? '<br/><em>Uppruni: '+selectedImage.credit+'</em>' : '')}
				/>
			}
			{
				props.data.length > 1 &&
				<div className="row">
					{
						props.data.map((file, index) => <div key={index} role="button" className="col col-3" onClick={() => setSelectedImage(file)}>
							<img src={config.mediaUrl+file.path}
								className={'mx-auto d-block rounded img-fluid mb-2'+(selectedImage && selectedImage.path == file.path ? ' border border-dark' : '')} />
						</div>)
					}
				</div>
			}
		</div>
	)
}

export default ImageList;
